var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 130,
    viewBox: "0 0 261 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3887 118.923H78.1499C74.3287 119.177 71.1238 115.562 71.1238 110.869V75.9881C71.1238 71.2316 74.3287 67.7436 78.1499 68.1241H82.9573C86.3471 68.4412 99.0435 73.7684 99.0435 78.0809V109.664C99.0435 113.913 86.7169 118.669 83.3887 118.923Z",
    fill: "url(#paint0_linear_1097_62261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5504 117.845L83.6353 118.923C79.814 119.177 76.6091 115.562 76.6091 110.869V75.9881C76.6091 71.2316 79.814 67.7436 83.6353 68.1241L98.5504 69.6461C101.94 69.9632 104.59 73.7684 104.59 78.0175V109.6C104.59 113.913 101.94 117.591 98.5504 117.845Z",
    fill: "url(#paint1_linear_1097_62261)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3934 60.7042C56.3934 49.3521 52.0174 39.0782 45.4227 33.9412L42.8342 30.5166H36.3627C25.4537 30.3263 16.332 43.2005 16.332 60.07C16.332 77.6372 26.1933 90.1942 37.5954 90.1942C37.9652 90.1942 45.4227 90.0674 45.4227 90.0674V87.0866C52.0174 82.2034 56.3934 72.0563 56.3934 60.7042Z",
    fill: "url(#paint2_linear_1097_62261)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.153 34.8923C100.153 25.3794 96.4548 16.7544 90.9695 12.5053L88.8124 9.65138H83.3887C74.267 9.52454 66.6245 20.2424 66.6245 34.3849C66.6245 49.0348 74.8217 59.5624 84.4364 59.5624C84.7446 59.5624 91.0311 59.499 91.0311 59.499V57.0256C96.4548 52.9034 100.153 44.4052 100.153 34.8923Z",
    fill: "url(#paint3_linear_1097_62261)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2962 60.704C63.2962 76.1783 55.1607 89.3695 44.4982 90.194C33.0961 91.0819 23.2349 77.6369 23.2349 60.0698C23.2349 42.5026 33.0961 29.3748 44.4982 30.5798C55.1607 31.7847 63.2962 45.1662 63.2962 60.704Z",
    fill: "url(#paint4_linear_1097_62261)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.364 34.8291C107.364 47.7666 100.584 58.8016 91.6472 59.4992C82.0941 60.2602 73.897 49.035 73.897 34.3852C73.897 19.7353 82.1558 8.76374 91.6472 9.77845C100.584 10.6663 107.364 21.8915 107.364 34.8291Z",
    fill: "url(#paint5_linear_1097_62261)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.702 125.758C141.702 127.575 140.748 129.123 139.497 129.221C138.158 129.325 137.001 127.748 137.001 125.691C137.001 123.633 138.158 122.089 139.497 122.232C140.748 122.365 141.702 123.94 141.702 125.758Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7014 8.53526C47.7014 10.3529 46.7467 11.9009 45.4962 11.9986C44.1568 12.1026 43 10.5254 43 8.46806C43 6.41072 44.1568 4.86646 45.4962 5.00914C46.7467 5.14234 47.7014 6.71768 47.7014 8.53526Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M230.13 5.06236C230.13 6.87997 229.175 8.42802 227.924 8.52572C226.585 8.62969 225.428 7.05246 225.428 4.99516C225.428 2.93782 226.585 1.39356 227.924 1.53624C229.175 1.66944 230.13 3.24478 230.13 5.06236Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1169 95.7149L84.5657 95.6281L94.0115 81.6301V109.019",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.893 99.5569C175.196 100.299 224.697 105.354 231.168 64.7429C234.491 43.8716 184.298 16.9101 166.345 18.4671C158.246 19.1691 105.112 25.3912 98.1086 27.0084C91.9139 28.4385 88.7712 31.7154 89.1626 35.6169C89.3401 37.3819 89.7512 41.052 96.5277 42.9197C97.5163 43.1936 98.5653 43.4391 99.6802 43.6528C106.098 44.9098 114.581 45.1806 124.773 43.7758C125.513 43.6756 127.237 43.5913 128.044 43.5272C128.074 43.5266 128.105 43.526 128.131 43.5247",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.648 64.3986C130.553 70.6968 132.707 85.8882 155.641 86.6968C170.811 87.2321 174.453 81.1356 175.382 75.4754",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.282 55.4222C131.547 65.0043 138.276 70.7127 154.954 71.4217C158.697 71.5809 168.2 71.683 172.968 67.1904",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.579 79.6973C132.91 81.3177 131.36 91.5428 142.233 97.2549C151.412 102.077 170.656 101.782 174.278 94.0402C176.217 89.8989 174.485 85.6175 170.61 83.7663",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182.892 40.2812C165.266 32.6759 161.512 39.5335 147.758 38.9088C132.255 38.2042 127.53 40.9705 127.497 46.1773C127.443 54.8625 138.422 60.4092 152.507 58.0919C158.62 57.0867 164.935 60.3775 170.382 62.1786C176.524 75.7859 186.343 85.1332 199.187 83.256",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 49.3216C39.446 45.6642 44.5477 44.0197 47.3256 48.7558C50.1032 53.4913 44.0541 57.2703 42.0925 57.8303C46.6583 59.2782 48.5728 62.3859 48.791 65.9948C48.9433 68.5083 45.4676 76.002 38.0993 71.3968",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1097_62261",
    x1: 71.1028,
    y1: 93.519,
    x2: 99.0688,
    y2: 93.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#195640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#197A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#199427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#19A420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AA1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1097_62261",
    x1: 76.652,
    y1: 93.519,
    x2: 104.618,
    y2: 93.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19AA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#23CC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CC29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1097_62261",
    x1: 16.3084,
    y1: 60.3702,
    x2: 56.3852,
    y2: 60.3702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#195640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#197A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#199427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#19A420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AA1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1097_62261",
    x1: 66.6011,
    y1: 34.6389,
    x2: 100.138,
    y2: 34.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#195640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#197A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#199427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#19A420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AA1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1097_62261",
    x1: 23.2139,
    y1: 60.4257,
    x2: 63.2907,
    y2: 60.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19AA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#23CC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CC29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1097_62261",
    x1: 73.8968,
    y1: 34.5964,
    x2: 107.373,
    y2: 34.5964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19AA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#23CC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CC29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.fe5dd8412493d4ab1c19c4fb3698e7c3.svg";
export { ForwardRef as ReactComponent };